import { createReducer, on } from '@ngrx/store';
import { DepartmentActions } from './department.actions';
import { DepartmentItem } from '@core/interface/department';
import { Pagination } from '@core/interface/core';

export const departmentFeatureKey = 'department';

export interface DepartmentState {
  departments: DepartmentItem[];
  isLoading: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  isDeleted: boolean;
  pagination: Pagination;
}

export const initialState: DepartmentState = {
  departments: [],
  isLoading: false,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const DepartmentReducer = createReducer(
  initialState,
  on(DepartmentActions.loadDepartments, (state) => ({
    ...state,
    isDeleted: false,
    loadError: null,
    isLoading: true,
  })),
  on(
    DepartmentActions.loadDepartmentsSuccess,
    (state, { data, pagination }) => ({
      ...state,
      departments: data,
      isLoading: false,
      isDeleted: false,
      loadError: null,
      pagination,
    })
  ),
  on(DepartmentActions.loadDepartmentsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    isDeleted: false,
    loadError: error,
  })),
  on(DepartmentActions.addDepartmentSuccess, (state, { data }) => ({
    ...state,
    departments: [...state.departments, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(DepartmentActions.addDepartmentFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(DepartmentActions.updateDepartmentSuccess, (state, { data }) => ({
    ...state,
    departments: state.departments.map((department) =>
      data.id == department.id ? data : department
    ),
    isDeleted: false,
    addEditError: null,
  })),
  on(DepartmentActions.updateDepartmentFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(DepartmentActions.deleteDepartmentSuccess, (state, { success, id }) => {
    return {
      ...state,
      isDeleted: success,
      deleteError: null,
      departments: state.departments.filter(
        (department) => department.id !== id
      ),
    };
  }),
  on(DepartmentActions.deleteDepartmentFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(DepartmentActions.deleteDepartment, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(DepartmentActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
  })),
  on(DepartmentActions.resetDepartments, (state) => ({
    ...state,
    departments: [],
  }))
);
